package ru.villawonka.app.presentation.screens.splash.compose.layout

import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import ru.villawonka.app.presentation.design.theme.surfaceMiddle
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_logo_140

@Composable
fun SplashLoadingStateLayout() {
    val logoSize = 140

    Box(
        modifier = Modifier
            .background(MaterialTheme.colors.surfaceMiddle)
            .fillMaxSize()
    ) {
        Box(
            modifier = Modifier
                .align(Alignment.Center)
                .size(logoSize.dp)
                .clip(RoundedCornerShape((logoSize * 0.30).dp))
        ) {
            Image(
                painter = painterResource(Res.drawable.ic_logo_140),
                contentDescription = null,
                modifier = Modifier.fillMaxSize()
            )
            ShimmerOverlay(
                modifier = Modifier
                    .fillMaxSize()
                    .alpha(0.20f)
            )
        }
    }
}

@Composable
private fun ShimmerOverlay(
    modifier: Modifier = Modifier,
    baseColor: Color = Color.White.copy(alpha = 0.3f),
    highlightColor: Color = Color.White.copy(alpha = 0.8f)
) {
    val infiniteTransition = rememberInfiniteTransition()
    val xOffset by infiniteTransition.animateFloat(
        initialValue = -1f,
        targetValue = 1f,
        animationSpec = infiniteRepeatable(
            animation = tween(1000, easing = LinearEasing),
            repeatMode = RepeatMode.Restart
        )
    )

    Box(modifier = modifier) {
        Canvas(modifier = Modifier.fillMaxSize()) {
            val gradient = Brush.linearGradient(
                colors = listOf(
                    baseColor,
                    highlightColor,
                    baseColor
                ),
                start = Offset(xOffset * size.width, 0f),
                end = Offset(xOffset * size.width + size.width * 2, size.height)
            )
            drawRect(brush = gradient)
        }
    }
}